var SPScript = require("spscript");
var utils = require("../../shared/utils")

var cache = require("../../shared/cache");
var cacheKey = "natp-breadcrumb";

// Public function that first tries to get it from cache
exports.getBreadcrumbTermId = function() {
    if (_spPageContextInfo && _spPageContextInfo.pageListId && _spPageContextInfo.pageItemId) {
        var listId = _spPageContextInfo.pageListId;
        var itemId = _spPageContextInfo.pageItemId
        // create new DAO using subsite's url
        var key = createPageCacheKey(listId, itemId)
        var cachedValue = cache.get(key);
        if (cachedValue) return Promise.resolve(cachedValue);
        return fetchBreadcrumbTermId(listId, itemId).then(id => cache.set(key, id));
    } 
    // Can't query for breadcrumb context so return empty value so it won't render
    return Promise.resolve("");
}

var createPageCacheKey = function(listId, itemId) {
    return `page-breadcrumb-value-${listId}-${itemId}`
};

var fetchBreadcrumbTermId = function(listId, itemId) {
    var dao = new SPScript.RestDao(_spPageContextInfo.webAbsoluteUrl)
    var url = `/lists('${listId}')/items('${itemId}')?$select=NATPBreadcrumb`

    return dao.get(url)
        .then(SPScript.utils.validateODataV2)
        .then(item => item && item.NATPBreadcrumb ? item.NATPBreadcrumb.TermGuid : "");
};

// Public function that first tries to get it from cache
exports.getFullBreadcrumb = function() {
    var cachedValue = cache.get(cacheKey);
    if (cachedValue) return Promise.resolve(cachedValue);
    return fetchFullBreadcrumb().then(b => cache.set(cacheKey, b));
}

var fetchFullBreadcrumb = function() {
    var url = `${utils.getFolderPath()}/breadcrumb.txt`;
    return SPScript.ajax({ url, method: "GET" } )
        .then(res => typeof res === "string" ? JSON.parse(res) : res)
};


// WEBPACK FOOTER //
// ./src/scripts/components/breadcrumb/data.js